import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// ** Extend Core's Collapse molecule **
export const Collapse = ({
  buttonContent,
  children,
  isActive,
  onClick,
  id,
  ...otherProps
}) => {
  //const [isExpanded, setIsExpanded] = useState(isActive);

  useEffect(() => {
    //setIsExpanded(isActive);
  }, [isActive])

  return (
    <>
      <tr className="mz-collapse mz-collapse-multi mzReactForms-component" id={'row_' + id}>
        <td>
          <button
            onClick={(e) => {
              if (onClick) {
                onClick(e);
              }
              //setIsExpanded(!isExpanded);
            }}
            className={`mz-collapse__button ${isActive ? 'active' : ''}`}
            {...otherProps}
          >
            {buttonContent}
            <i className={`mz-svg mz-svg-chevroncarousel mz-svg--grey${isActive ? 'visible' : ''}`}></i>
          </button>
        </td>
      </tr>
      {children}
    </>
  )
}

Collapse.propTypes = {
  buttonContent: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
}

Collapse.defaultProps = {
  isActive: false,
  onClick: undefined
}

export default Collapse;